import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ title, subtitle, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#eef7fd] via-white to-[#eefaf3] border-b">
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #148a45 1px, transparent 0)", backgroundSize: "24px 24px" }}
      />
      <div className="container-page relative py-12 md:py-16">
        <nav className="flex items-center gap-1.5 text-sm text-muted-foreground mb-4">
          <Link to="/" className="hover:text-primary">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3.5 w-3.5" />
              {c.to ? <Link to={c.to} className="hover:text-primary">{c.label}</Link> : <span className="text-foreground font-medium">{c.label}</span>}
            </span>
          ))}
        </nav>
        <h1 className="font-heading text-3xl md:text-4xl font-bold max-w-3xl text-foreground">{title}</h1>
        {subtitle && <p className="mt-3 max-w-2xl text-muted-foreground">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, desc, center = true }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-12`}>
      {eyebrow && (
        <span className="inline-block rounded-full bg-secondary px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary mb-3">
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground">{title}</h2>
      {desc && <p className="mt-3 text-muted-foreground">{desc}</p>}
    </div>
  );
}
